import CutwiseAPIClient, { METHOD_DELETE, METHOD_PATCH } from '@/common/network/CutwiseAPIClient';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';
import { DriveProjectAccessRequestDto } from '@/security/types/DriveProjectAccessRequestDto';
import { PrivateAccessUpdateResult } from '@/security/types/PrivateAccessUpdateResult';

export const PATH_DRIVE_ITEM_SECURITY_ACCESS = 'api/v1/entity-access/drive-nodes';

// user cannot disable recursive for drive projects access
export const DRIVE_PROJECT_ACCESS_REQUEST_RECURSIVE = true;

interface GlobalAccessUpdateBody {
  access: GlobalAccessLevel;
  dataAccess: ProjectDataAccess;
  inheritAccess?: boolean;
}

export default class DriveSecurityAPI {
  updateGlobalAccess(
    id: DriveItemId,
    accessLevel: GlobalAccessLevel,
    dataAccess: ProjectDataAccess,
    shouldInheritAccess?: boolean,
  ) {
    const body: GlobalAccessUpdateBody = { access: accessLevel, dataAccess };

    if (shouldInheritAccess !== undefined) {
      body.inheritAccess = shouldInheritAccess;
    }

    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_PATCH)
      .path(`${PATH_DRIVE_ITEM_SECURITY_ACCESS}/${id}/global-access`)
      .body(body);

    return CutwiseAPIClient.sendQuery(qb.getQuery());
  }

  async updateACL(id: DriveItemId, request: DriveProjectAccessRequestDto[]): Promise<PrivateAccessUpdateResult[]> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_PATCH)
      .path(`${PATH_DRIVE_ITEM_SECURITY_ACCESS}/${id}/access-grant`)
      .body({ accessGrantRequests: request });

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());

    return res.content;
  }

  async deleteACL(driveNodeId: DriveItemId, userEmails: string[]): Promise<PrivateAccessUpdateResult[]> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_DELETE)
      .path(`${PATH_DRIVE_ITEM_SECURITY_ACCESS}/${driveNodeId}/access-grant`)
      .body(userEmails.map((email) => ({ email, recursive: DRIVE_PROJECT_ACCESS_REQUEST_RECURSIVE })));

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());

    return res.content;
  }
}
